// Import required libraies
import moment from "moment";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../../msalConfig";

// Import data
import breadcrumbsMapping from "../../assets/data/breadcrumbsMapping.json";

import { config } from "../config/config";

import DOMPurify from "dompurify";

// INPUT SANITATION CODE
export const sanitizeUserInput = (value) => {
  if (typeof value !== "string") return value;

  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS: [], // ❌ No HTML tags
    ALLOWED_ATTR: [], // ❌ No attributes
    KEEP_CONTENT: true, // ✅ Keep text content
  });
};

// Escapes regex special characters before building dynamic regex
const escapeRegex = (str = "") => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

// Checks if a string contains dangerous code patterns
const validateInput = (value = "") => {
  if (typeof value !== "string") return false;

  const normalized = value.replace(/\s+/g, " ").trim().toLowerCase();

  const dangerousPatterns = [
    // Real script tags only
    /<\s*script\b[^>]*>/i,
    /<\/\s*script\s*>/i,

    // JavaScript execution vectors
    /\bjavascript\s*:/i,
    /\bon\w+\s*=\s*/i,

    // Dangerous browser APIs
    /\bdocument\s*\.\s*cookie\b/i,
    /\bwindow\s*\.\s*location\b/i,
    /\bwindow\s*\.\s*open\b/i,

    // Dynamic execution
    /\beval\s*\(/i,
    /\bnew\s+function\b/i,
    /\bsettimeout\s*\(/i,
    /\bsetinterval\s*\(/i,
  ];

  return dangerousPatterns.some((pattern) => pattern.test(normalized));
};

// Checks for unsupported special characters.
export const hasInvalidCharacters = (
  value = "",
  allowedSpecialCharacters = "_.,()'\"=<>!%*+-/:;[]|&@",
) => {
  if (typeof value !== "string") return false;

  const escapedAllowedChars = escapeRegex(allowedSpecialCharacters);

  const allowedRegex = new RegExp(`^[a-zA-Z0-9\\s${escapedAllowedChars}]*$`);

  return !allowedRegex.test(value);
};

// Main validation function for user input to check for dangerous code and unsupported special characters
export const hasDangerousCode = (
  value = "",
  allowedSpecialCharacters = "_.,()'\"=<>!%*+-/:;[]|&@",
) => {
  if (hasInvalidCharacters(value, allowedSpecialCharacters)) {
    return {
      isValid: false,
      error: "Unsupported special characters detected.",
    };
  }

  if (validateInput(value)) {
    return {
      isValid: false,
      error: "Invalid or unsafe input detected.",
    };
  }

  return {
    isValid: true,
    error: "",
  };
};

// Get current year
export const getCurrentYear = () => moment().year();

// Split path/ url to make breadcrumb
export const splitUrlToBreadcrumbData = (url) => {
  let routes = url.replace(/^\//g, "").replace(/\/$/g, "").split("/");
  let data = routes.map((name, index) => ({
    name,
    label: breadcrumbsMapping[name]
      ? breadcrumbsMapping[name]
      : index >= 2
        ? name.split("_").splice(0)[0]
        : name,
    path: routes
      .slice(0, index + 1)
      .reduce((finalPath, route) => finalPath + route + "/", "/"),
  }));
  return data;
};

export const useUserAuthentication = () => {
  const { instance } = useMsal();

  const login = () => {
    localStorage.clear();
    sessionStorage.clear();
    instance.loginRedirect(loginRequest);
  };

  return { login };
};

// export const useUserAuthentication = () => {
//   const clientId = config.api.clientId;
//   const redirect_Uri = config.api.redirect_Uri;
//   const authorizationEndpoint = config.api.authorizationEndpoint;

//   const loginUrl =
//     `${authorizationEndpoint}?client_id=${clientId}` +
//     `&redirect_uri=${encodeURIComponent(redirect_Uri)}` +
//     "&response_type=code" +
//     "&scope=openid user.read";
//   window.location.href = loginUrl;
// };
